import { Query } from '@/utils/react-query/Queries';

/** Resolve the task's own scope, never infer it from its team or an unrelated room. */
export default function useTaskInstanceLocation(taskInstance) {
    const id = taskInstance?.locationID;
    const embedded = taskInstance?.Location;
    const eventLocations = [
        ...(taskInstance?.EventInstance?.Locations || []),
        ...(taskInstance?.EventInstance?.Event?.Locations || []),
    ].map(location => location.Location || location);
    const name = id && ((embedded && (!embedded.id || embedded.id === id) ? embedded.name : null)
        || eventLocations.find(location => location.id === id)?.name);
    const { data, isLoading } = Query.locations.byId({
        id,
        options: { enabled: !!id && !name },
    });
    return id ? name || (data?.id === id ? data.name : null) || (isLoading ? 'Loading location…' : 'Location unavailable') : null;
}
